import { FC, useEffect, useMemo, useState } from 'react'
import { FormEntryField } from '../../../core/type'
import { useQuery } from '@apollo/client'
import { GetVendorsForLookup } from '../graphql/contact.queries.graphql'
import { Select } from 'antd'
import { SelectProps } from 'antd/es/select'
import { vendorOptionLabel, vendorSortKey } from './vendorLabel.util'

export type VendorSelectProps = FormEntryField<number> & {
  mode?: SelectProps['mode']
}

const LOOKUP_TAKE = 5000

export const VendorSelect: FC<VendorSelectProps> = ({value, onChange, mode}) => {
  const [search, setSearch] = useState<string>()
  const {data, loading} = useQuery(GetVendorsForLookup, {
    variables: {
      request: {
        isVendor: true,
        take: LOOKUP_TAKE,
        skip: 0,
        contactId: search?.trim() || undefined,
      },
    },
  })


  useEffect(() => {
    const found = data?.contactsFind
    if (found && found.count > found.data.length) {
      console.warn(`VendorSelect: vendor list truncated to ${found.data.length} of ${found.count} rows`)
    }
  }, [data])

  const options = useMemo(
    () => [...(data?.contactsFind.data ?? [])]
      .sort((a, b) => vendorSortKey(a).localeCompare(vendorSortKey(b)))
      .map(v => ({
        label: vendorOptionLabel(v),
        value: v.id,
      })),
    [data],
  )

  return (
    <Select
      allowClear
      mode={mode}
      loading={loading}
      filterOption={false}
      options={options}
      onSearch={setSearch}
      onDropdownVisibleChange={open => open && setSearch(undefined)}
      value={value}
      onChange={next => {
        setSearch(undefined)
        onChange?.(next)
      }}
    />
  )
}